import React from 'react';

const HeroVideoBackdrop = () => {
  return (
    <div aria-hidden className="absolute inset-0 overflow-hidden z-0" data-testid="hero-video-backdrop">
      <video
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        className="absolute inset-0 w-full h-full object-cover"
        style={{ filter: 'saturate(0.65) brightness(1.10) sepia(0.25)' }}
      >
        <source src="/reel/r1.mp4" type="video/mp4" />
      </video>

      {/* Cream wash overlay - tuned for the light beige theme (lighter, less hazy) */}
      <div
        className="absolute inset-0"
        style={{
          background:
            'linear-gradient(180deg, rgba(245,237,224,0.30) 0%, rgba(245,237,224,0.20) 40%, rgba(235,224,206,0.35) 75%, rgba(224,210,187,0.55) 100%)',
        }}
      />
      <div
        className="absolute inset-0"
        style={{
          background:
            'radial-gradient(ellipse 65% 55% at 50% 55%, rgba(184,136,74,0.05) 0%, rgba(245,237,224,0.18) 55%, rgba(224,210,187,0.32) 95%)',
        }}
      />
    </div>
  );
};

export default HeroVideoBackdrop;
